//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class NotificationClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('notification-api');
  }
}

@inject(String, HttpClient)
export class NotificationsClient extends NotificationClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("NotificationsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5710", baseUrl);
    }

    async getToken(companyIdentityId: number): Promise<NatsUserToken> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Notifications/token", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Notifications/token";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetToken(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetToken(response: Response): Promise<NatsUserToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatsUserToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatsUserToken>(null as any);
    }
}

export class NatsUserToken implements INatsUserToken {
    sessionId?: string;
    jwt?: string;
    seed?: string;
    env?: string;

    constructor(data?: INatsUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["SessionId"];
            this.jwt = _data["Jwt"];
            this.seed = _data["Seed"];
            this.env = _data["Env"];
        }
    }

    static fromJS(data: any): NatsUserToken {
        data = typeof data === 'object' ? data : {};
        let result = new NatsUserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionId"] = this.sessionId;
        data["Jwt"] = this.jwt;
        data["Seed"] = this.seed;
        data["Env"] = this.env;
        return data;
    }
}

export interface INatsUserToken {
    sessionId?: string;
    jwt?: string;
    seed?: string;
    env?: string;
}

export enum NotifyStatus {
    Pending = 0,
    InProgress = 1,
    InProgressUpdate = 2,
    Success = 3,
    Error = 4,
    Warning = 5,
}

export enum NotifyType {
    Step = 0,
    Main = 1,
}

export enum NotifyStepType {
    Parse = 0,
    Hydrate = 1,
    CreateVoucher = 2,
    GeneratePdf = 3,
}

export class EntityChanged implements IEntityChanged {
    companyIdentityId?: number;
    type?: string;
    eventType?: string | undefined;
    data?: any;
    ts?: string | undefined;
    activityId?: string | undefined;
    notifyStepMessage?: string | undefined;
    notifyStatus?: NotifyStatus | undefined;
    notifyStepId?: string | undefined;
    notifyTimeStamp?: string;
    notifyMainMessage?: string | undefined;
    notifyStepProgress?: number | undefined;
    notifyType?: NotifyType | undefined;
    notifyStepType?: NotifyStepType;

    constructor(data?: IEntityChanged) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.type = _data["Type"];
            this.eventType = _data["EventType"];
            this.data = _data["Data"];
            this.ts = _data["Ts"];
            this.activityId = _data["ActivityId"];
            this.notifyStepMessage = _data["NotifyStepMessage"];
            this.notifyStatus = _data["NotifyStatus"];
            this.notifyStepId = _data["NotifyStepId"];
            this.notifyTimeStamp = _data["NotifyTimeStamp"];
            this.notifyMainMessage = _data["NotifyMainMessage"];
            this.notifyStepProgress = _data["NotifyStepProgress"];
            this.notifyType = _data["NotifyType"];
            this.notifyStepType = _data["NotifyStepType"];
        }
    }

    static fromJS(data: any): EntityChanged {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChanged();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["Type"] = this.type;
        data["EventType"] = this.eventType;
        data["Data"] = this.data;
        data["Ts"] = this.ts;
        data["ActivityId"] = this.activityId;
        data["NotifyStepMessage"] = this.notifyStepMessage;
        data["NotifyStatus"] = this.notifyStatus;
        data["NotifyStepId"] = this.notifyStepId;
        data["NotifyTimeStamp"] = this.notifyTimeStamp;
        data["NotifyMainMessage"] = this.notifyMainMessage;
        data["NotifyStepProgress"] = this.notifyStepProgress;
        data["NotifyType"] = this.notifyType;
        data["NotifyStepType"] = this.notifyStepType;
        return data;
    }
}

export interface IEntityChanged {
    companyIdentityId?: number;
    type?: string;
    eventType?: string | undefined;
    data?: any;
    ts?: string | undefined;
    activityId?: string | undefined;
    notifyStepMessage?: string | undefined;
    notifyStatus?: NotifyStatus | undefined;
    notifyStepId?: string | undefined;
    notifyTimeStamp?: string;
    notifyMainMessage?: string | undefined;
    notifyStepProgress?: number | undefined;
    notifyType?: NotifyType | undefined;
    notifyStepType?: NotifyStepType;
}

export class GlUpdatedEvent implements IGlUpdatedEvent {
    voucherIds?: string[];

    constructor(data?: IGlUpdatedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["VoucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["VoucherIds"])
                    this.voucherIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GlUpdatedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new GlUpdatedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherIds)) {
            data["VoucherIds"] = [];
            for (let item of this.voucherIds)
                data["VoucherIds"].push(item);
        }
        return data;
    }
}

export interface IGlUpdatedEvent {
    voucherIds?: string[];
}

export class Notification implements INotification {
    id?: string;
    date?: string;
    type?: NotificationType;
    companyIdentityId?: number;
    text?: string;
    data?: string;
    steps?: NotificationStep[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.date = _data["Date"];
            this.type = _data["Type"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.text = _data["Text"];
            this.data = _data["Data"];
            if (Array.isArray(_data["Steps"])) {
                this.steps = [] as any;
                for (let item of _data["Steps"])
                    this.steps!.push(NotificationStep.fromJS(item));
            }
            this.activityTraceId = _data["ActivityTraceId"];
            this.lastAccessed = _data["LastAccessed"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Date"] = this.date;
        data["Type"] = this.type;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["Text"] = this.text;
        data["Data"] = this.data;
        if (Array.isArray(this.steps)) {
            data["Steps"] = [];
            for (let item of this.steps)
                data["Steps"].push(item ? item.toJSON() : undefined as any);
        }
        data["ActivityTraceId"] = this.activityTraceId;
        data["LastAccessed"] = this.lastAccessed;
        return data;
    }
}

export interface INotification {
    id?: string;
    date?: string;
    type?: NotificationType;
    companyIdentityId?: number;
    text?: string;
    data?: string;
    steps?: NotificationStep[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;
}

export enum NotificationType {
    ProcessDocument = 1,
    SendVouchersToGl = 2,
    ProcessVouchers = 3,
    TaxValuesImport = 4,
    ConfirmGlPosting = 5,
    FetchGlAccounts = 6,
    FetchGlTransactions = 7,
    MergeInstrument = 20,
}

export class NotificationStep implements INotificationStep {
    notificationId?: string;
    step?: number;
    stepName?: string;
    companyIdentityId?: number;
    date?: string;
    status?: NotificationStepStatus;
    text?: string;
    debugMessage?: string | undefined;
    errorType?: NotificationErrorType;
    expectedProgress?: number;
    currentProgress?: number;
    progresses?: NotificationStepProgress[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;

    constructor(data?: INotificationStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
            this.step = _data["Step"];
            this.stepName = _data["StepName"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.date = _data["Date"];
            this.status = _data["Status"];
            this.text = _data["Text"];
            this.debugMessage = _data["DebugMessage"];
            this.errorType = _data["ErrorType"];
            this.expectedProgress = _data["ExpectedProgress"];
            this.currentProgress = _data["CurrentProgress"];
            if (Array.isArray(_data["Progresses"])) {
                this.progresses = [] as any;
                for (let item of _data["Progresses"])
                    this.progresses!.push(NotificationStepProgress.fromJS(item));
            }
            this.activityTraceId = _data["ActivityTraceId"];
            this.lastAccessed = _data["LastAccessed"];
        }
    }

    static fromJS(data: any): NotificationStep {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        data["Step"] = this.step;
        data["StepName"] = this.stepName;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["Date"] = this.date;
        data["Status"] = this.status;
        data["Text"] = this.text;
        data["DebugMessage"] = this.debugMessage;
        data["ErrorType"] = this.errorType;
        data["ExpectedProgress"] = this.expectedProgress;
        data["CurrentProgress"] = this.currentProgress;
        if (Array.isArray(this.progresses)) {
            data["Progresses"] = [];
            for (let item of this.progresses)
                data["Progresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["ActivityTraceId"] = this.activityTraceId;
        data["LastAccessed"] = this.lastAccessed;
        return data;
    }
}

export interface INotificationStep {
    notificationId?: string;
    step?: number;
    stepName?: string;
    companyIdentityId?: number;
    date?: string;
    status?: NotificationStepStatus;
    text?: string;
    debugMessage?: string | undefined;
    errorType?: NotificationErrorType;
    expectedProgress?: number;
    currentProgress?: number;
    progresses?: NotificationStepProgress[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;
}

export enum NotificationStepStatus {
    Pending = 0,
    InProgress = 1,
    Success = 2,
    Error = 3,
    Warning = 4,
}

export enum NotificationErrorType {
    Unknown = 0,
    LockDate = 1,
    Authentication = 2,
    DatabaseError = 3,
}

export class NotificationStepProgress implements INotificationStepProgress {
    notificationId?: string;
    step?: number;
    date?: string;
    companyIdentityId?: number;

    constructor(data?: INotificationStepProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
            this.step = _data["Step"];
            this.date = _data["Date"];
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): NotificationStepProgress {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStepProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        data["Step"] = this.step;
        data["Date"] = this.date;
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface INotificationStepProgress {
    notificationId?: string;
    step?: number;
    date?: string;
    companyIdentityId?: number;
}

export class InsightBaseContract implements IInsightBaseContract {
    companyIdentityId?: number;

    constructor(data?: IInsightBaseContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): InsightBaseContract {
        data = typeof data === 'object' ? data : {};
        let result = new InsightBaseContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface IInsightBaseContract {
    companyIdentityId?: number;
}

export class ClientNotification extends InsightBaseContract implements IClientNotification {
    notification?: Notification | undefined;
    step?: NotificationStep | undefined;
    progress?: NotificationStepProgress | undefined;
    natsSequence?: number | undefined;

    constructor(data?: IClientNotification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notification = _data["Notification"] ? Notification.fromJS(_data["Notification"]) : undefined as any;
            this.step = _data["Step"] ? NotificationStep.fromJS(_data["Step"]) : undefined as any;
            this.progress = _data["Progress"] ? NotificationStepProgress.fromJS(_data["Progress"]) : undefined as any;
            this.natsSequence = _data["NatsSequence"];
        }
    }

    static override fromJS(data: any): ClientNotification {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNotification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Notification"] = this.notification ? this.notification.toJSON() : undefined as any;
        data["Step"] = this.step ? this.step.toJSON() : undefined as any;
        data["Progress"] = this.progress ? this.progress.toJSON() : undefined as any;
        data["NatsSequence"] = this.natsSequence;
        super.toJSON(data);
        return data;
    }
}

export interface IClientNotification extends IInsightBaseContract {
    notification?: Notification | undefined;
    step?: NotificationStep | undefined;
    progress?: NotificationStepProgress | undefined;
    natsSequence?: number | undefined;
}

export enum ProcessDocumentNotificationStep {
    Parse = 2,
    CreateVoucher = 3,
    Hydrate = 4,
    GeneratePdf = 5,
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}